import { Component } from 'react';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { LORAX } from 'HubStyleTokens/colors';
import UISelectableButton from 'UIComponents/button/UISelectableBox';
import UIIcon from 'UIComponents/icon/UIIcon';
import { getColorStyleWithOpacity } from 'MeetingsLib/utils/color';
import { track } from 'MeetingsLib/tracking/UsageTracker';
import FreemiumViralTrackingPixel from 'MeetingsLib/tracking/FreemiumViralTrackingPixel';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export default class FreemiumUpgradeButton extends Component {
  constructor(...args) {
    super(...args);
    this.handleTreatmentFetched = () => {
      this.setState({
        treatmentFetched: true
      });
    };
    this.handleViralButtonClick = () => {
      if (this.state.experimentEnabled) {
        track('meetingsLibViralityExperiment', {
          action: 'click',
          variation: this.state.variation
        });
      }
      this.props.handleButtonClick();
    };
    this.getBrandingActiveStyle = () => {
      const {
        branding: {
          primaryColor
        }
      } = this.props;
      if (!primaryColor) {
        return null;
      }
      return {
        width: 'auto',
        borderColor: primaryColor,
        backgroundColor: getColorStyleWithOpacity(primaryColor)
      };
    };
    this.getBrandingTextStyle = () => {
      const {
        branding: {
          primaryColor
        }
      } = this.props;
      if (!primaryColor) {
        return null;
      }
      return {
        color: primaryColor
      };
    };
  }
  componentDidMount() {
    track('meetingsViralityPageView', {
      action: 'virality-thank-you-page-view'
    });
    this.handleTreatmentFetched();
  }
  render() {
    const {
      handleButtonClick,
      portalId,
      embedded
    } = this.props;
    const linkType = 'meetings-thankyou';
    return /*#__PURE__*/_jsxs(UISelectableButton, {
      padded: false,
      selected: false,
      className: "freemium-advert-button",
      style: Object.assign({}, this.getBrandingActiveStyle()),
      onClick: handleButtonClick,
      children: [/*#__PURE__*/_jsx(UIIcon, {
        name: "sprocket",
        color: LORAX,
        className: "m-right-1"
      }), /*#__PURE__*/_jsx("span", {
        style: Object.assign({}, this.getBrandingTextStyle()),
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "summary.meetingsAdvert.freemium"
        })
      }), portalId > -1 && /*#__PURE__*/_jsx(FreemiumViralTrackingPixel, {
        portalId: portalId,
        embedded: embedded,
        viralLinkType: linkType
      })]
    });
  }
}